"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCarsSimilar = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var selectors_1 = require("../redux/selectors");
var createUrl_1 = require("../helpers/car/createUrl");
var useCarsSimilar = function (car) {
    var _a = (0, react_redux_1.useSelector)(selectors_1.mediaQuerySelector), isMedium = _a.isMedium, isSmall = _a.isSmall;
    var _b = react_1.default.useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = react_1.default.useState(false), isError = _c[0], setIsError = _c[1];
    var _d = react_1.default.useState([]), carsSimilar = _d[0], setCarsSimilar = _d[1];
    var slidesPerView = react_1.default.useMemo(function () {
        if (isSmall)
            return 1;
        return isMedium ? 2 : 3;
    }, [isSmall, isMedium]);
    react_1.default.useEffect(function () {
        var fetchSimilarCars = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, cars, transformCarsBrand, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, 4, 5]);
                        return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_details?").concat((0, createUrl_1.createUrl)(typeof car.brand === 'string' ? car.brand : car.brand.name, car.model.name, car.generation.name, ((_a = car.unique_id) !== null && _a !== void 0 ? _a : '').toString())), {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                            })];
                    case 1:
                        response = _b.sent();
                        if (!response.ok) {
                            throw new Error('Failed to fetch similar cars');
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        cars = _b.sent();
                        transformCarsBrand = cars.map(function (auto) {
                            return __assign(__assign({}, auto), { brand: auto.brand.name });
                        });
                        setCarsSimilar(transformCarsBrand);
                        setIsError(false);
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        setIsError(true);
                        return [3 /*break*/, 5];
                    case 4:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchSimilarCars();
    }, [car.brand, car.model.name, car.generation.name, car.unique_id]);
    return {
        isLoading: isLoading,
        isError: isError,
        carsSimilar: carsSimilar,
        slidesPerView: slidesPerView,
    };
};
exports.useCarsSimilar = useCarsSimilar;
